import { first } from "lodash";
import { Observable } from "rxjs";
import { HTTPError } from "superagent";
import { store } from "..";
import { createEnum } from "../../utils/utils";
import { AuthActions } from "../auth/actions";
import { ErrorActions } from "./actions";

const ApiError2Codes = createEnum({
  invalid_token: "Invalid Token",
});

type ApiError = HTTPError & {
  response: {
    body: {
      errors: Array<{
        errorCode: string;
        description: string;
      }>;
    };
  };
};

type ApiError2 = HTTPError & {
  //TODO : fix inconsistency
  response: {
    body: {
      error: typeof ApiError2Codes.T;
      error_description: string;
    };
  };
};

export function isApiError(x: Error): x is ApiError {
  return (
    Array.isArray((x as any)?.response?.body?.errors) &&
    (x as any)?.response?.body?.errors?.[0]?.errorCode !== undefined
  );
}
export function isApiError2(x: Error): x is ApiError2 {
  return (x as any)?.response?.body?.error !== undefined;
}

export function isHttpError(
  x: any
): x is Error & {
  status: number;
} {
  return !isNaN(x.status);
}

export function processErrorFromPromiseForAuth<T, K extends Error>(
  err: K
): Promise<T> {
  if (
    !isApiError(err) &&
    !isApiError2(err) &&
    isHttpError(err) &&
    err.status === 401
  ) {
    store.dispatch(AuthActions.clearAuthState());
    store.dispatch(ErrorActions.setError(new Error("bad-credentials")));
    if (process.env.NODE_ENV === "development") {
      console.error(err);
    }
    return Promise.reject(err);
  }
  return processErrorFromPromise(err);
}

export function processErrorFromPromise<T, K extends Error>(
  err: K
): Promise<T> {
  if (process.env.NODE_ENV === "development") {
    console.error(err);
  }
  if (isApiError(err)) {
    // TODO: use error code as well
    store.dispatch(
      ErrorActions.setError(
        new Error(err.response.body.errors?.[0]?.description)
      )
    );
  } else if (isApiError2(err)) {
    if (err.response.body.error === "invalid_token") {
      store.dispatch(AuthActions.clearAuthState());
      store.dispatch(
        ErrorActions.setError(new Error("your-session-has-expired"))
      );
    } else {
      store.dispatch(
        ErrorActions.setError(new Error(err.response.body.error_description))
      );
    }
  } else if (isHttpError(err)) {
    if (err.status === 401) {
      //TODO repeating what is above
      store.dispatch(AuthActions.clearAuthState());
      store.dispatch(
        ErrorActions.setError(new Error("your-session-has-expired"))
      );
    } else {
      store.dispatch(ErrorActions.setError(new Error("an-error-has-occured")));
      //TODO: log this cause unexpected
    }
  } else {
    store.dispatch(ErrorActions.setError(err));
  }

  return Promise.reject(err);
}
